import styled from 'styled-components';

export const LactomamaDetail = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .head {
    font-size: 22px;
    font-weight: 600;
    text-align: center;
    padding-bottom: 12px;
    color: ${(props) => props.tabThemeColor || '#498A5B'};
    span {
      font-weight: bold;
      color: rgba(0, 0, 0, 0.87);
    }
  }
  .background {
    padding: 40px 0;
    background-image: radial-gradient(
      circle,
      #e2ffea 56%,
      rgba(226, 255, 234, 0) 80%,
      #fff
    );
  }
  .lactoGif {
    width: 100%;
  }
  .healthWrapper {
    width: 100%;
    padding-top: 12px;
  }
`;

export const ImageOuter = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 67%;
  .image {
    object-fit: contain;
  }
`;

export const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  background: #f8f9fa;
  border-radius: 8px;
  margin: 0 auto;
  max-width: fit-content;
  width: auto;

  @media (max-width: 768px) {
    padding: 6px 12px;
    gap: 4px;
  }
`;

export const StarIcon = styled.div`
  font-size: 18px;
  color: #ffa500;

  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 3px;
  }
`;

export const RatingText = styled.span`
  font-size: 18x;
  font-weight: 400;
  color: #ffa500;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const RatingCount = styled.span`
  font-size: 14px;
  color: #666;
  font-weight: 400;


  @media (max-width: 768px) {
    font-size: 14px;
    font-weight: 400;
  }
`;

export const ReviewsLink = styled.button`
  background: none;
  border: none;
  color: #333333;
  font-size: 14px;
  font-weight: 400;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  margin-left: 4px;
  margin-top: 1px;
  font-family:'montserrat', sans-serif;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
